import { Component, Vue, Watch } from 'vue-property-decorator'
import { IMatchupList, IMatchup, IPick } from '@/store/modules/game/interfaces'
import HeadToHead from './HeadToHead'
import OverUnder from './OverUnder'
import HeadToHeadClassic from './HeadToHeadClassic'
import OverUnderClassic from './OverUnderClassic'
import Loader from './Loader'
import { GetOUFantasyAspect } from '@/utils/GameUtils'
import { PickToSelection } from '@/store/modules/cart/interfaces'
import _ from 'lodash'
import { EventBus } from '@/utils/eventbus'
import { Route } from 'vue-router'

export interface IMatchupType {
  matchup: IMatchup;
}

export interface IFilter {
  id: string;
  name: string;
  disabled: boolean;
}

@Component
export class MatchupList extends Vue {
  private matchups: IMatchupList = { matchups: { personal: [], all: []} } as IMatchupList

  private isClassic =  this.$store.getters.ISCLASSIC

  public sportFilter: IFilter[] = [
    {id: 'all', name: 'ALL', disabled: false} as IFilter
  ]

  private typeFilter: IFilter[] = this.isClassic ? ([
    {id: 'h2h', name: 'Head to Head', disabled: false} as IFilter, 
    {id: 'ou', name: 'Over/Under', disabled: true} as IFilter, 
  ]) : ([
    {id: 'h2h', name: 'Head to Head', disabled: false} as IFilter, 
    {id: 'ou', name: 'Over/Under', disabled: false} as IFilter, 
  ])

  public sortOrder: IFilter[] = this.isClassic ? [
    {id: 'fppg', name: 'FPPG', disabled: false} as IFilter,
  ] : [
    {id: 'ordinal', name: 'Ordinal', disabled: false} as IFilter,
  ]

  private currentSport: IFilter = this.sportFilter[0]
  private currentFilter: IFilter = this.typeFilter[0]
  private currentSort: IFilter = this.sortOrder[0]

  private created() {
    this.getSource()
  }

  private getSource() {
    this.$store.dispatch('SET_LOADINGSTATE', true)
    this.$store.dispatch('GET_MATCHUPS').then( (res: IMatchupList) => {
      this.matchups.matchups.all = res.matchups.all.sort((a: IMatchup, b: IMatchup) => {
        if (this.currentSort.id === 'fppg') {
          return (b.pickA.player.fppg || 0) - (a.pickA.player.fppg || 0)
        }
  
        return b.ordinal - a.ordinal
      })
      this.$store.dispatch('GET_PERSONALISED_MATCHUPS').then( (res: IMatchupList) => {
        this.matchups.matchups.personal = res.matchups.all.map( (matchup: IMatchup) => {
          matchup.tags.push('cohort:personal')
          return matchup
        }).sort((a: IMatchup, b: IMatchup) => {
          if (this.currentSort.id === 'fppg') {
            return (b.pickA.player.fppg || 0) - (a.pickA.player.fppg || 0)
          }
    
          return b.ordinal - a.ordinal
        })
      })
    }).catch((err: any) => {
      this.$store.dispatch('SET_LOADINGSTATE', false)
    })
  }

  private addLoadersToSource() {
    this.matchups.matchups.personal = this.$store.getters.PERSONALISED_MATCHUPS.matchups.all
  }

  private mounted() {
    this.currentSport = this.sportFilter[0]

    EventBus.$on('globalTick', () => {
      const st = this.$store.getters.SETTLEMENTTIME
      const now = Date.now()
      if (st <= now) {
        this.getSource()
      }
    })

    EventBus.$on('boughtMatchups', () => {
        this.getSource()
    })

    EventBus.$on('preBoughtMatchups', () => {
      this.addLoadersToSource()
    })
    
    EventBus.$emit('gameLobbyLoaded')
  }

  private beforeDestroy() {
    EventBus.$off('globalTick')
  }

  selectClick(matchup: IMatchup, pick: IPick, variant: string) {
    const cartCount = this.$store.getters.SELECTIONS_COUNT

    if (cartCount >= 10) {
      return
    }

    const toSave = PickToSelection(matchup, pick, variant, this.isClassic)
    this.$store.dispatch('SET_PICK', toSave)

    // @ts-ignore
    heap.track('game:matchup:select', {
      'matchup': toSave.matchupId, 
      // @ts-ignore
      'pickId': toSave.pick.player.id, 
      // @ts-ignore
      'pickPos': toSave.pick.matchupPosition, 
      'variant': toSave.mode
    })
  }

  removeClick(matchup: IMatchup, pick: IPick, variant: string) {
    const toSave = PickToSelection(matchup, pick, variant, this.isClassic)
    this.$store.dispatch('REMOVE_PICK', toSave)

    // @ts-ignore
    heap.track('game:matchup:remove', {
      'matchup': toSave.matchupId, 
      // @ts-ignore
      'pickId': toSave.pick.player.id, 
      // @ts-ignore
      'pickPos': toSave.pick.matchupPosition, 
      'variant': toSave.mode
    })
  }

  private sportfilterClick(filter: IFilter, evt: object) {
    if (filter.disabled) { return false }

    this.currentSport = filter;
    // @ts-ignore
    heap.track('game:filter:sport', {'filter': filter})
  }

  private typefilterClick(filter: IFilter, evt: object) {
    if (filter.disabled) { return false }
    this.currentFilter = filter;
    // @ts-ignore
    heap.track('game:filter:type', {'filter': filter})
  }

  expandAssetUrl(tags: string[]) {
    var tag = _.find(tags, function(f) {
      return f.split(':')[0] === 'asset';
    })

    if (!tag) { return; }
    return 'https://' + tag.split(':')[1]
  };

  private render(h: any): any {
    const typefilters = this.typeFilter.map((filter) => { 
      let classBuilder = this.currentFilter.id === filter.id ? `active l${this.typeFilter.length}` : `l${this.typeFilter.length}`
      
      if (filter.disabled) {
        classBuilder = `${classBuilder} inactive`
      }
      
      return (
      <label for={'option-' + filter.id} onClick={this.typefilterClick.bind(this, filter)} class={classBuilder}>
        <input type='radio' id={'option-' + filter.id} name='selector'></input>
        {filter.name}
      </label>
    )});

    const sportfilters = this.sportFilter.map((filter) => { 
      let classBuilder = this.currentSport.id === filter.id ? `active l${this.sportFilter.length}` : `l${this.sportFilter.length}`
      
      if (filter.disabled) {
        classBuilder = `${classBuilder} inactive`
      }

      return (
      <label for={'option-' + filter.id} onClick={this.sportfilterClick.bind(this, filter)} class={classBuilder}>
        <input type='radio' id={'option-' + filter.id} name='selector'></input>
        {filter.name}
      </label>
    )});

    let matchupRender: JSX.Element[] | null = null

    if (this.$store.getters.MATCHUPSPENDING) {
      return;
    }

    this.$store.dispatch('SET_LOADINGSTATE', false)

    let matchupList = this.matchups.matchups.all.concat(this.matchups.matchups.personal).filter((matchup: IMatchup, idx: number) => {
      const aspect = matchup.pickA.player.aspect.id.toLocaleLowerCase()

      let filterForAspect = false
      //if we're on all
      if (this.currentSport.id === this.sportFilter[0].id) {
        if (this.isClassic) {
          //if we're in classic we only want ones starting with Z
          if (aspect.charAt(0) === 'z') { filterForAspect = true }
        } else {
          //if we're not in classic we only want ones not starting with z
          if (aspect.charAt(0) !== 'z') { filterForAspect = true }
        }
      }

      if (this.currentSport.id === aspect) {
        filterForAspect = true
      }

      return filterForAspect && (this.currentFilter.id === GetOUFantasyAspect(matchup.pickB)) 
    })

    let h2hCount: number = 0;
    let ouCount: number = 0;
    
    matchupRender = matchupList.map((matchup: IMatchup) => {
      if (matchup.reason === 'loader') {
        // @ts-ignore
        return (<Loader matchup={matchup}></Loader>)
      }

      if (GetOUFantasyAspect(matchup.pickB) === 'ou') {
        ouCount++;
        if (this.isClassic) {
          // @ts-ignore
          return (<OverUnderClassic matchup={matchup}></OverUnderClassic>)
        }
        // @ts-ignore
        return (<OverUnder matchup={matchup}></OverUnder>)
      } else {
        h2hCount++;
        if (this.isClassic) {
          // @ts-ignore
          return (<HeadToHeadClassic matchup={matchup}></HeadToHeadClassic>)
        }
        // @ts-ignore
        return (<HeadToHead matchup={matchup}></HeadToHead>)
      }
    }) 

    if (matchupRender !== null && matchupList.length < 1) {
      if (this.isClassic) {
        matchupRender = [(<div class='blank-avatar'>Waiting on new matchups...</div>)]
      } else {
        matchupRender = [(<div class='blank-avatar'>
          New matchups coming soon<br></br>
          <router-link class='navigation-link' to='/virtual'>Switch to Virtual</router-link>
        </div>)]
      }
    }
    
    if (h2hCount === 0 && ouCount > 0) {
      this.currentFilter = this.typeFilter[1]
    }

    EventBus.$emit('matchupsloaded', matchupRender.length)

    return (
      <section class='matchups'>
        <nav class='sports-filters'>
          {sportfilters}
        </nav>
        <nav class='matchups-filters'>
          {typefilters}
        </nav>
        <div class='matchup-cards'>
          {matchupRender}
        </div>
      </section>
    );
  }
}

export class LiveList extends MatchupList {
  public sportFilter: IFilter[] = [
    {id: 'all', name: 'ALL', disabled: false} as IFilter,
    {id: 'nfl', name: 'NFL', disabled: false} as IFilter,
    {id: 'nba', name: 'NBA', disabled: false} as IFilter,
    {id: 'mlb', name: 'MLB', disabled: false} as IFilter,
    {id: 'pga', name: 'PGA', disabled: false} as IFilter,
    {id: 'nhl', name: 'NHL', disabled: false} as IFilter,
    {id: 'nascar', name: 'NASCAR', disabled: false} as IFilter,
    {id: 'ufc', name: 'UFC', disabled: false} as IFilter
  ]
}

export class VirtualList extends MatchupList {
  public sportFilter: IFilter[] = [
    {id: 'zall', name: 'ALL', disabled: false} as IFilter,
    {id: 'znfl', name: 'NFL', disabled: false} as IFilter, 
    {id: 'znba', name: 'NBA', disabled: false} as IFilter,
  ]
}
